export function resolveStepDataWithoutInstance<T>(
  pathname: string,
  currentStepData: T | null,
): T | null {
  return /^\/courses\/[^/]+(?:\/|$)/.test(pathname) ? currentStepData : null;
}

export function isCourseLessonStep(pageContextType: string): boolean {
  return pageContextType === 'course';
}
